(function() {
  'use strict';
  //TODO refactor and remove CYBERSOURCE
  angular.module('eclipseApp.checkout').controller('buyCreditCheckCtrl', [
    '$scope',
    'util',
    '$state',
    'uteModal',
    '$rootScope',
    '$timeout',
    'uteSemafoneService',
    'buyService',
    'buyUtils',
    'notifier',
    'cartManager',
    'commonService',
    'dtmService',
    'dtmServiceConstants',
    'brtSwitchCMS',
    function(
      $scope,
      util,
      $state,
      uteModal,
      $rootScope,
      $timeout,
      uteSemafoneService,
      buyService,
      buyUtils,
      notifier,
      cartManager,
      commonService,
      dtmService,
      dtmServiceConstants,
      brtSwitchCMS
    ) {
      //
      //--- INITS ----------------------------------------------
      //

      var _self = {};

      $scope.isHybridFlow = brtSwitchCMS.brtSwitch.isHybridFlow;
      angular.extend(_self, {
        driverLicense: {
          visited: false
        },
        certificate: {
          visited: false
        },
        citizenship: {
          visited: false
        },
        creditCard: {
          visited: false
        },
        employee: {
          visited: false
        },
        passport: {
          visited: false
        },
        seniorCitizen: {
          visited: false
        },
        sin: {
          visited: false
        },
        studentPermit: {
          //FHSI Student Permit
          visited: false
        }
      });

      $scope.driverLicense = {};
      $scope.certificate = {};
      $scope.citizenship = {};
      $scope.creditCard = {};
      $scope.employee = {};
      $scope.passport = {};
      $scope.seniorCitizen = {};
      $scope.sin = {};
      $scope.studentPermit = {}; //FHSI Student Permit
      $scope.dob = {};

      $scope.profileCreditCheck = {};
      $scope.profileCreditCheck.hasConsent = false;
      $scope.PACButtonClicked = false;
      $scope.creditCheckResultFlag = '';
      $scope.addNewClass = false;
      $scope.hasBeenSubmitted = false;

      $scope.riskClassContent = {};

      //semafone initial
      uteSemafoneService.clearData();

      // hide first id selector on load
      $scope.dobIsValid = false;

      //$scope.firstIdOptionObject = {
      //  prop12: 'checkout:creditcheck:firstID:{{idType}}',
      //};
      //
      //$scope.secondIdOptionObject = {
      //  prop12: 'checkout:creditcheck:secondID:{{idType}}'
      //};

      // TODO
      $scope.today = new Date();

      buyService.setStepVisited($state.current.name, $scope.buyMethods.initFormsScope);

      //FUSS-1515 - DTM tracking for buy credit check step 2
      var tierInCart = cartManager.internet.tierInCart();
      if (tierInCart) {
        if (tierInCart.selectedOffer && tierInCart.selectedOffer.offerPrice) {
          dtmService.setVar(dtmServiceConstants.dtmRules.buyInternet.selectedProduct, tierInCart.selectedOffer.offerId);
          dtmService.setVar(
            dtmServiceConstants.dtmRules.buyInternet.productPrice,
            tierInCart.selectedOffer.offerPrice.price
          );
        }
        dtmService.direct(dtmServiceConstants.dtmRules.buyInternet.creditCheck.ruleName);

        /* DSO-15392 start */
        if ($rootScope.promoOfferId === null || $rootScope.discountOffers === null) {
          if (
            commonService.customerHasInternetService &&
            commonService.internetAccountStatus !== 'SUSPENDED' &&
            commonService.internetAccountStatus !== 'CANCELLED'
          ) {
          } else {
            var isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
            if (isOfferIdEligible === null) {
              buyService.getInternetPromos().then(function(data) {
                if (data) {
                  isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
                  $rootScope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                  $rootScope.discountOffers = buyService.getDiscountOffers();
                }
              });
            } else {
              $rootScope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
              $rootScope.discountOffers = buyService.getDiscountOffers();
            }
          }
        } else if (tierInCart && $rootScope.discountOffers === null && !$rootScope.ruiMethods.user.is.loggedIn()) {
          buyService.getInternetPromos().then(function(data) {
            $scope.discountOffers = data;
          });
        }
        /* DSO-15392 end */
      }

      //--- RULES ----------------------------------------------

      // set driver license validations depending on selected province
      $scope.dlNumberValidations = {
        BC: '(\\d{7})',
        AB: '(^\\d{6}\\d{3}$)|(^\\d{6}\\-\\d{3}$)',
        MB:
          '(^[a-zA-Z]{2}[a-zA-Z]{2}[a-zA-Z]{2}[a-zA-Z]{1}\\d{3}[a-zA-Z]{2}$)|(^[a-zA-Z]{2}\\-[a-zA-Z]{2}\\-[a-zA-Z]{2}\\-[a-zA-Z]{1}\\d{3}[a-zA-Z]{2}$)',
        NB: '(\\d{7})',
        NL: '([a-zA-Z]{1}\\d{9})',
        NS: '([a-zA-Z]{5}\\d{9})',
        ON: '(^[a-zA-Z]{1}\\d{4}\\d{5}\\d{5}$)|(^[a-zA-Z]{1}\\d{4}\\-\\d{5}\\-\\d{5}$)',
        PE: '(\\d{1,6})',
        QB: '(^[a-zA-Z]{1}\\d{4}\\d{6}\\d{2}$)|(^[a-zA-Z]{1}\\d{4}\\-\\d{6}\\-\\d{2}$)',
        NT: '(\\d{6})',
        SK: '(\\d{8})'
      };

      $scope.getMonthLabel = function(param) {
        if (param) {
          return moment(param, 'M').format('MMMM');
        }
      };

      $scope.ccNumberPatterns = {
        V: '(^\\d{16}$)|(^\\d{4}\\ [0-9]{4}\\ [0-9]{4}\\ [0-9]{4}$)|(^\\d{4}-\\d{4}-\\d{4}-\\d{4})',
        A: '(^\\d{15}$)|(^\\d{4}\\s\\d{6}\\s\\d{5}$)|(^\\d{4}-\\d{6}-\\d{5}$)',
        M: '(^\\d{4}\\d{4}\\d{4}\\d{4}$)|(^\\d{4}\\ \\d{4}\\ \\d{4}\\ \\d{4}$)|(^\\d{4}-\\d{4}-\\d{4}-\\d{4})',
        D: '([0-9]{4}[ -]?){4}'
      };

      $scope.range = function(min, max, step) {
        step = step || 1;
        var input = [];
        for (var i = min; i <= max; i += step) input.push(i);
        return input;
      };

      // TODO: deprecate and use _
      $scope.reverseRange = function(max, min, step) {
        step = step || 1;
        var input = [];
        for (var i = max; i >= min; i -= step) input.push(i);
        return input;
      };

      buyService
        .getContentWithDynamicContent({
          tags: {
            retail: 'retail.error.inline.age.underage',
            consumer: 'global.error.inline.age.underage'
          },
          flag: '[age]',
          value: buyService.getAgeOfMajority()
        })
        .then(function(resp) {
          $scope.creditCheckMinimumAge = resp;
        });

      $scope.getPermission = buyService.getPermission;

      if ($scope.forms.creditCheck.riskClassFlag && !$scope.forms.creditCheck.allowPAC) {
        $scope.creditCheckResultFlag = $scope.forms.creditCheck.riskClassName;
      }

      $scope.cancelPAC = function() {
        $state.go('cartSummary');
      };

      $scope.continueWithPac = function() {
        $scope.PACButtonClicked = true;
        if ($scope.forms.creditCheck.allowPAC) {
          // $scope.forms.creditCheck.pending = false;
          // console.log('@buyCreditCheckCtrl:continueWithPac:creditCheck.pending ', $scope);
          buyService.doOperation('validateCart', { showProgress: true });
        }
      };

      $scope.creditCheckRule = {
        // ccNumber: { pattern: '([0-9]{4}[ -]?){4}' },
        //ccExpiryMonth: { type: 'number', min: 1, max: 12 },
        //ccExpiryYear: { type: 'number', min: $scope.today.getFullYear(), max: $scope.today.getFullYear() + 10 },

        // rename after demo all with prefix `first_`
        dlProvince: { type: 'number', min: 1, max: 11 },
        dlExpiryDay: { type: 'number', min: 1, max: 31 },
        dlExpiryMonth: { type: 'number', min: 1, max: 10 },
        dlExpiryYear: { type: 'number', min: $scope.today.getFullYear(), max: $scope.today.getFullYear() + 9 },
        dlLicenseNumber: {},

        sinNumber: { pattern: '^\\d{9}$' },

        ppNumber: {},
        ppProvince: { type: 'number', min: 1, max: 10 },
        ppExpiryMonth: { type: 'number', min: 1, max: 10 },
        ppExpiryYear: { type: 'number', min: $scope.today.getFullYear(), max: $scope.today.getFullYear() + 9 },
        ppExpiryDay: {},

        birthCertificateNumber: { pattern: '^\\w{1,20}$' },
        citizenshipNumber: { pattern: '^\\w{1,20}$' },
        employer: { type: 'number', min: 1, max: 2 },
        employeeNumber: { pattern: '^[0-9a-zA-Z]{1,20}$' },

        day: { pattern: '^\\d{1,2}$' },
        month: { pattern: '^\\d{1,2}$' },
        year: { pattern: '^\\d{4}$' },

        //FHSI Student Permit - Validation rules for Expiry date - START
        spExpiryDay: { type: 'number', min: 1, max: 31 },
        spExpiryMonth: { type: 'number', min: 1, max: 10 },
        spExpiryYear: { type: 'number', min: $scope.today.getFullYear(), max: $scope.today.getFullYear() + 9 },
        //studentPermitNumber:{pattern: '^\\d{8,11}$', minlength: 8}
        studentPermitNumber: { pattern: '^([a-zA-Z]{2})?[0-9]{8,11}$', minlength: 8 }
        //FHSI Student Permit - Validation rules for Expiry date - END

        //ccExpiryMonth: { pattern: '^\\d{1,2}$' },
        //ccExpiryYear: { pattern: '^\\d{4}$' },
      };

      $scope.setConsent = function(val) {
        // console.log('@setConsent:val ', val);
        $scope.profileCreditCheck.hasConsent = val;
      };
      $scope.hasConsent = function() {
        // console.log('@hasConsent: ', $scope.profileCreditCheck.hasConsent);
        return $scope.profileCreditCheck.hasConsent;
      };

      // default passport - maxlength is 8
      $scope.ppMaxLength = 8;

      $scope.updateCreditCheckRule = function() {
        // set the passport number pattern based on Primary ID
        $scope.ppNumberPattern = $scope.firstIdOption == 9 ? '(^[.\\S]{3,20}$)' : '(^[a-zA-Z]{2}\\d{6}$)';
        // set the max length of the passport field based on Primary ID
        $scope.ppMaxLength = $scope.firstIdOption == 9 ? 20 : 8;
      };

      // get saved session data if user decided to go back to page
      var userData = $scope.forms[$state.current.name];
      if (userData && userData.profileCreditCheck) {
        var data = userData.profileCreditCheck.data;
        if (data) {
          $scope.driverLicense = data.driverLicense || {};
          $scope.certificate = data.certificate || {};
          $scope.citizenship = data.citizenship || {};
          $scope.creditCard = data.creditCard || {};
          $scope.employee = data.employee || {};
          $scope.passport = data.passport || {};
          $scope.seniorCitizen = data.seniorCitizen || {};
          $scope.sin = data.sin || {};
          $scope.dob = data.dob || {};
          $scope.studentPermit = data.studentPermit || {};
          $scope.firstIdOption = data.firstIdOption;
          $scope.secondIdOption = data.secondIdOption;
          $scope.ccType = data.ccType;
          $scope.profileCreditCheck.hasConsent = data.hasConsent;
          $scope.creditCheckResultFlag = data.resultFlag;
        }
      }

      $scope.ccType; // used to show credit card type

      $scope.isDateValid = function(dateObj, idForm, idType, idScope) {
        // this validation function is called by none date selectors so it will be validated only when year, month, and day is set.
        if ((dateObj && !dateObj.year) || !dateObj.month || !dateObj.day) return;

        if (idForm) {
          if ($scope.rootCreditCheckForm[idForm.$name]) {
            if (idScope) {
              // set $scope[idScope].validExpiryDate Bool value
              // handles displaying of inline error messages

              // $scope[idScope].validExpiryDate = (moment(date, 'YYYY-MM-DD').isValid() && (moment(date, 'YYYY-MM-DD')).diff(moment(), 'days') > -1);
              $scope[idScope].validExpiryDate = buyUtils.isValidExpiryDate(dateObj);

              // set form ng-invalid-date flag depending on value of $scope[idScope].validExpiryDate
              // handles invalidity of form preventing user to submit
              $scope.rootCreditCheckForm[idForm.$name].$setValidity('invalidDate', $scope[idScope].validExpiryDate);
              // return $scope[idScope].validExpiryDate;
              // console.log('---isDateValid IF ', $scope);
            }
          }
        } else {
          // if @param idForm is not defined
          // return Bool value based on date's validity check:
          // is a valid leap-year;
          // is selected day is a valid day in selected month
          // console.log('---isDateValid ELSE ', $scope);

          return buyUtils.isValidDate(dateObj);
        }
      };

      $scope.changeCcExpiryDate = function(selectedObj, idForm) {
        if (selectedObj.month) $scope.creditCard.ccExpiryMonth = selectedObj.month.$viewValue;
        else if (selectedObj.year) $scope.creditCard.ccExpiryYear = selectedObj.year.$viewValue;

        if ($scope.creditCard.ccExpiryMonth && $scope.creditCard.ccExpiryYear) {
          if ($scope.creditCard.ccExpiryYear == new Date().getFullYear()) {
            $scope.rootCreditCheckForm[idForm.$name].ccExpiryMonth.$setValidity(
              'invalidDate',
              parseInt($scope.creditCard.ccExpiryMonth) > new Date().getMonth()
            );
            return false;
          } else {
            $scope.rootCreditCheckForm[idForm.$name].ccExpiryMonth.$setValidity('invalidDate', true);
            return true;
          }
        }
      };

      $scope.isDobValid = function() {
        return buyUtils.isDobValid({ day: $scope.dob.day, month: $scope.dob.month, year: $scope.dob.year });
      };

      $scope.setCCType = function(evt, input) {
        var ccNumber = evt.target.value;
        if (ccNumber.length > 3) {
          if (ccNumber.match(/^(34|37)/)) {
            $scope.ccType = 'A';
            input.$setValidity('invalidFormat', true);
          } else if (ccNumber.match(/^(4|13)/)) {
            $scope.ccType = 'V';
            input.$setValidity('invalidFormat', true);
          } else if (ccNumber.match(/^5[1-5]/)) {
            $scope.ccType = 'M';
            input.$setValidity('invalidFormat', true);
          } else {
            $scope.ccType = 'D';

            /*
             * @else
             * @param input => ngModelController Object
             * Set input invalid with error as required
             * if input value did not fall under given regex types of ccards
             *
             */

            input.$setValidity('invalidFormat', false);
          }
        } else if (ccNumber.length < 3) {
          $scope.ccType = '';
        }
      };

      $scope.getFormView = buyUtils.getFormTemplate;

      // set data object to store ss response data

      $scope.$on('Checkout:CompleteStep', function(ev, data) {
        console.log('!!!!!!!x');
        saveSession();
        console.log('!!!!!!!xy');
        $scope.completedForm(data.stepName);
        console.log('!!!!!!!xzz');
        // $scope.completedForm('fulfillment');
        // $scope.completedForm('paymentOptions');
      });

      if ($scope.forms.creditCheck.rcCode) {
        getRiskClassMessage($scope.forms.creditCheck.rcCode);
      }

      $scope.$on('CreditCheck:HasRiskClass', function(ev, success) {
        setRiskClassCode(success.riskClassCode);

        getRiskClassMessage($scope.forms.creditCheck.rcCode);

        switch (success.riskClass) {
          case 'FRAUD':
            // console.log('---@case:FRAUD', success);
            notifier.notify.done();

            $scope.forms.creditCheck.riskClassFlag = true;
            $scope.forms.creditCheck.riskClassRedirect = true;

            $scope.forms.creditCheck.riskClassName = success.riskClass;
            $scope.buyMethods.navigateAwayFromCheckout('login');

            $timeout(function() {
              uteModal.open({
                templateUrl: 'modules/checkout/views/credit-check-fraud-modal.html',
                controller: 'riskClassModalCtrl',
                data: {
                  riskClassCode: success.riskClassCode
                }
              });

              // delete session
              buyService.deleteCheckoutSession();
            });
            break;
          case 'MANUAL_REVIEW':
            // console.log('---@case:MANUAL_REVIEW ', success);
            notifier.notify.done();
            $scope.forms.creditCheck.riskClassFlag = true;
            $scope.forms.creditCheck.pending = true;
            $scope.forms.creditCheck.riskClassName = 'MANUAL_REVIEW';
            $scope.completedForm('creditCheck', false);
            setCreditCheckRiskClassFlag(success.riskClass);
            break;
          case 'CONDITIONAL_APPROVAL':
            // console.log('---@case:CONDITIONAL_APPROVAL ', success);
            notifier.notify.done();
            $scope.forms.creditCheck.riskClassFlag = true;
            $scope.forms.creditCheck.pending = true;
            $scope.forms.creditCheck.riskClassName = 'CONDITIONAL_APPROVAL';
            // if credit check results in preauthorized only show view
            setCreditCheckRiskClassFlag(success.riskClass);
            // save session in case user will proceed
            saveSession();
            // set step as complete but prevent from auto navigating to next step
            $scope.completedForm('creditCheck', false);
            break;
          case 'NEGATIVE':
            $scope.forms.creditCheck.riskClassFlag = true;
            $scope.forms.creditCheck.riskClassName = 'NEGATIVE';
            // console.log('---@case:NEGATIVE ', success);
            notifier.notify.done();
            // notifier.notify.error({riskClassCode: success.riskClassCode, templateUrl: 'modules/checkout/views/fragments/modal/credit-check-risk-class-negative.html'});
            uteModal.open({
              templateUrl: 'modules/checkout/views/credit-check-misc-class-modal.html',
              controller: 'riskClassModalCtrl',
              data: {
                riskClassCode: success.riskClassCode,
                requestIndepthEvalMethod: $scope.requestIndepthEval
              }
            });
          // setCreditCheckRiskClassFlag(success.riskClass);
        }
      });

      $scope.creditCheckMethods = {
        requestIndepthEval: function() {
          buyService.requestIndepthEval().then(
            function(res) {
              $scope.forms.creditCheck.riskClassRedirect = true;

              // redirect user to home
              // then show success message
              // clean session
              $scope.buyMethods.navigateAwayFromCheckout('login');
              buyService.deleteCheckoutSession();

              $timeout(function() {
                uteModal.open({
                  templateUrl: 'views/templates/modal/credit-check-request-submitted-modal.html',
                  controller: 'riskClassModalCtrl',
                  data: {
                    riskClassCode: $scope.forms.creditCheck.riskClassCode
                  }
                });
              });
            },
            function(res) {
              _satellite.setVar('error', 'FHSI | buyCreditcheck  failed');
              _satellite.track('bfa-fhsi-error');
              notifier.notify.error();
            }
          );
        }
      };

      // TODO deprecate
      $scope.requestIndepthEval = function() {
        buyService.requestIndepthEval().then(
          function(res) {
            $scope.forms.creditCheck.riskClassRedirect = true;

            // redirect user to home
            // then show success message
            // clean session
            $scope.buyMethods.navigateAwayFromCheckout('login');
            buyService.deleteCheckoutSession();
            $timeout(function() {
              uteModal.open({
                templateUrl: 'views/templates/modal/credit-check-request-submitted-modal.html',
                controller: 'riskClassModalCtrl',
                data: {
                  riskClassCode: $scope.forms.creditCheck.riskClassCode
                }
              });
            });
          },
          function(res) {
            _satellite.setVar('error', 'FHSI | creditcheck  failed');
            _satellite.track('bfa-fhsi-error');
            notifier.notify.error();
          }
        );
      };
      $scope.toggleSubmittedValue = function() {
        $scope.hasBeenSubmitted = false;
      };

      var ccNo; // ccNumber will get stored here because ccNumber in scope will be replaced with tokenized-number;
      // prevents clashing with tokenized ccNumber in scope

      // TODO: refactor
      $scope.submitCreditCheck = function(formName) {
        $scope.addNewClass = true;
        $scope.hasBeenSubmitted = true;
        //DSO-12647 scroll to the first error
        $timeout(function() {
          var errorList = [];
          errorList = document.getElementsByClassName('ute-message error ng-active');
          if (errorList.length > 0) {
            var iElement = 0;
            while (errorList[iElement].getClientRects().length <= 0 && errorList.length > iElement) {
              iElement++;
            }
            if (errorList[iElement] && errorList[iElement].getClientRects().length > 0) {
              var yPos = errorList[iElement].getClientRects()[0].top;
              var scrollValue =
                yPos -
                document.getElementsByClassName('create-profile-menu-holder')[0].offsetHeight -
                document.getElementById('header').offsetHeight -
                95;
              window.scrollBy(0, scrollValue);
            }
          }
        });

        console.log('----SUBMITTING----');

        var firstIdOption = $scope.firstIdOption,
          secondIdOption = $scope.secondIdOption,
          firstFormIdName,
          secondFormIdName;

        // console.log('@submitCreditCheck:BEFORE ( CCNO, ng.equals(), $scope.creditCheck.ccNumber ) ', ccNo, angular.equals(ccNo, $scope.creditCard.ccNumber), $scope.creditCard.ccNumber);

        // ccNo is undefined on first submit
        if (angular.isUndefined(ccNo)) {
          // store ccNumber to ccNo on first submit
          ccNo = $scope.creditCard.ccNumber;

          // console.log('--1');
          // if ccNo is not undefined -> it has a ccNumber as value
          // and ccNo is not equal to ccNumber in scope -> user has entered a new ccNumber
        } else if (!angular.isUndefined(ccNo) && !angular.equals(ccNo, $scope.creditCard.ccNumber)) {
          // if ccNumber is not equal what is stored in ccNo ->
          // check if ccNumber is a valid ccNumber
          if (!util.getCCType($scope.creditCard.ccNumber)) {
            ccNo = ccNo;
          } else {
            ccNo = $scope.creditCard.ccNumber;
          }
          // console.log('--2');
        }
        // if ccNo is equal to the ccNumber in scope
        // -> user has selected the same ccNumber upon submitting
        // else if (angular.equals(ccNo, $scope.creditCard.ccNumber)) {

        //   ccNo = ccNo;
        //   console.log('--3');
        // }

        // console.log('@submitCreditCheck:AFTER ( CCNO, ng.equals(), $scope.creditCard.ccNumber ) ', ccNo, angular.equals(ccNo, $scope.creditCard.ccNumber), $scope.creditCard.ccNumber);

        formName.$setSubmitted();

        // case 1: user haven't chosen any ids and submitted
        if (!$scope[formName.$name].firstIdOption.$modelValue && !$scope[formName.$name].secondIdOption.$modelValue) {
          // alert('Two IDs are required to perform a credit evaluation.');

          // uteModal.open({
          //   templateUrl: 'modules/checkout/views/warning-modal.html',
          //   controller: 'WarningModalCtrl',
          //   data: {
          //     title: 'Please provide two ID\'s',
          //     message: 'We\'ll need two pieces of ID\'s from you to perform credit-evaluation.'
          //   }
          // });

          // case 2: user has selected one id and have not yet filled it
          // case 3: user attempted to submit without choosing a second id
          if ($scope[formName.$name].firstIdOption.$modelValue) {
            (firstFormIdName = _idTypes()[parseInt(firstIdOption)].formName),
              // when user has selected first id -> check its validity
              $scope[formName.$name][firstFormIdName].$setSubmitted();
          }

          return;
        } else if (firstIdOption && !secondIdOption) {
          // case 3: user attempted to submit without choosing a second id
          if (firstIdOption) {
            (firstFormIdName = _idTypes()[parseInt(firstIdOption)].formName),
              // when user has selected first id -> check its validity
              $scope[formName.$name][firstFormIdName].$setSubmitted();
          }

          return;
        } else if (!firstIdOption && secondIdOption) {
          // case 3: user attempted to submit without choosing a second id
          if (secondIdOption) {
            (firstFormIdName = _idTypes()[parseInt(secondIdOption)].formName),
              // when user has selected first id -> check its validity
              $scope[formName.$name][firstFormIdName].$setSubmitted();
          }

          return;
        } else if (firstIdOption && secondIdOption) {
          (firstFormIdName = _idTypes()[parseInt(firstIdOption)].formName),
            (secondFormIdName = _idTypes()[parseInt(secondIdOption)].formName),
            // case 4: user has selected two ids -> setSubmitted and let NG handle errors
            $scope[formName.$name][firstFormIdName].$setSubmitted();
          $scope[formName.$name][secondFormIdName].$setSubmitted();

          // case 5: user has selected two ids -> check forms validity
          // if all two ids are valid -> try submitting
          if ($scope[formName.$name][firstFormIdName].$valid && $scope[formName.$name][secondFormIdName].$valid) {
            // case 6: two ids are valid, but haven't approved consent yet
            if (!$scope.profileCreditCheck.hasConsent) {
              console.log('BE CONSENTIOUS DUDE');
              var consentElement = document.getElementById('credit_check_consent');
              if (consentElement && consentElement.getClientRects().length > 0) {
                var scrollValue =
                  consentElement.getClientRects()[0].top -
                  document.getElementsByClassName('create-profile-menu-holder')[0].offsetHeight -
                  document.getElementById('header').offsetHeight -
                  50;
                window.scrollBy({ top: scrollValue });
              }
              // let ng handle form validation errors

              return;
            }
          } // case 5
        }

        // do a last check to make sure the root form is valid and let ng handle error
        if (formName.$invalid) {
          return;
        }

        // check if credit card is chosen as an id then do cybersource  TODO to be removed
        if (_.includes([$scope.firstIdOption, $scope.secondIdOption], '1')) {
          console.log('---HAS CREDIT CARD AS ID---');
          // $scope.validateCreditCard(ccNo); //TODO remove all cybersource dependence

          $scope.validateSemafoneCreditInfo(ccNo);
        } else {
          console.log('---NO CREDIT CARD AS ID---');

          buyService.doOperation('searchCustomerDetails', {
            data: setPayloadData(),
            showProgress: true
          });
        }
      };

      $scope.validateSemafoneCreditInfo = function() {
        $scope.error = '';
        $scope.creditCard.maskedCardNumber = uteSemafoneService.getMaskedCardNumber();
        $scope.creditCard.maskedToken = uteSemafoneService.getToken();
        $scope.ccType = buyUtils.getCCType().byFullCCName(uteSemafoneService.getCardScheme());
        $scope.creditCard.ccNumber = uteSemafoneService.getToken();

        if ($scope.creditCard.ccNumber === null || $scope.creditCard.ccNumber === '') {
          // TODO: French translation needed.
          _satellite.setVar('error', 'FHSI | validateSemafoneCreditInfo failed');
          _satellite.track('bfa-fhsi-error');

          $scope.error = 'Invalid credit card - failed decryption';
          notifier.notify.error({
            errorCode: 'cybinvalid'
          });
        } else {
          // proceed to searchCustomerDetails once got seamfone token

          buyService.doOperation('searchCustomerDetails', {
            data: setPayloadData(),
            showProgress: true
          });
          console.log('>XXXXXXXXXXXXXXXXXXXX');
          // /else
        }
      };

      //TODO remove cybersource dependence
      $scope.validateCreditCard = function(ccNumber) {
        //$scope.error = '';
        //
        //uteCyberSource.getEncryptedToken(ccNumber).then(
        //  function (resp) {
        //
        //    var encrypted = resp.data;
        //
        //    // debug
        //    // var encrypted = {iin: '000000',token: '9604184769591111',cardType: 'V',rc: '101'};
        //    // end debug
        //
        //    angular.extend($scope.creditCard, { enc: encrypted });
        //
        //    if (encrypted.rc === '100') {
        //
        //      // debug
        //      // var data = {decrypt: '9604184769591111'};
        //      // $scope.creditCard.maskedToken = uteCyberSource.getMaskedToken(data.decrypt);
        //      // $scope.ccType = encrypted.cardType;
        //      // $scope.creditCard.ccNumber = data.decrypt;
        //
        //      // buyService.doOperation('searchCustomerDetails', {data: setPayloadData()}, true);
        //      // return;
        //      // end debug
        //
        //
        //      uteCyberSource.getDecryptedToken(encrypted, encrypted.cardType).success(function (data) {
        //        if (data.decrypt) {
        //
        //          $scope.creditCard.maskedToken = uteCyberSource.getMaskedToken(data.decrypt);
        //          $scope.ccType = encrypted.cardType;
        //          $scope.creditCard.ccNumber = data.decrypt;
        //
        //
        //          // proceed to searchCustomerDetails once cybersource is done and succeeds
        //          buyService.doOperation('searchCustomerDetails', { data: setPayloadData() }, true);
        //        } else {
        //          // TODO: French translation needed.
        //          $scope.error = 'Invalid credit card - failed decryption';
        //          notifier.notify.error({errorCode: 'cybinvalid'});
        //          return false;
        //        }
        //      });
        //    } else {
        //      // TODO: French translation needed.
        //      console.log('getEnc: else');
        //      $scope.error = 'Invalid credit card - failed decryption';
        //      notifier.notify.error({errorCode: 'cybinvalid'});
        //      return false;
        //    }
        //  }, function () {
        //    // TODO: French translation needed.
        //    $scope.error = 'Unexpected credit card encryption error';
        //    notifier.notify.error({errorCode: 'cybinvalid'});
        //    return false;
        //  }
        //);
      };

      $scope.isIdValid = function(formName, optionId) {
        var firstId = $scope[formName.$name].firstIdOption.$modelValue,
          secondId = $scope[formName.$name].secondIdOption.$modelValue,
          _secondFormIdName,
          _firstFormIdName;

        // check if ids are valid -> return the opposite Boolean value
        if (
          firstId &&
          secondId &&
          $scope[formName.$name][_firstFormIdName] &&
          $scope[formName.$name][_secondFormIdName]
        ) {
          _secondFormIdName = _idTypes()[parseInt(secondId)].formName;
          _firstFormIdName = _idTypes()[parseInt(firstId)].formName;

          return !($scope[formName.$name][_firstFormIdName].$valid && $scope[formName.$name][_secondFormIdName].$valid)
            ? true
            : false;
        }
      };

      /*
       * @method validateField
       * @description handle consistent form validation of when toggling from one form ID to another.
       * In use together with the event listener $on.('$includeContentLoaded').
       *
       */
      $scope.validateField = function(fieldName) {
        var _rootForm = $scope.rootCreditCheckForm,
          _firstIdFormContext,
          _secondIdFormContext,
          _firstIdFormName,
          _secondIdFormName,
          _checkFlag = fieldName + 'Form';

        if ($scope.firstIdOption) {
          _firstIdFormName = setIds($scope.firstIdOption).formName;
        }

        if ($scope.secondIdOption) {
          _secondIdFormName = setIds($scope.secondIdOption).formName;
        }

        console.log('@validateField:ROOT ', _firstIdFormName, _secondIdFormName);

        if (_checkFlag && _firstIdFormName) {
          _firstIdFormContext = _rootForm[setIds($scope.firstIdOption).formName];

          console.log('@validateField:IF 1ID ', _firstIdFormContext, _firstIdFormName);

          switch (_firstIdFormName) {
            case 'creditCardForm':
              // _self.creditCard.ccNumber = _firstIdFormContext.ccNumber.$viewValue;
              // _self.creditCard.ccType = $scope.ccType;
              _self.creditCard.ccNumber = uteSemafoneService.getToken();
              _self.creditCard.ccType = uteSemafoneService.getCardScheme();
              _self.creditCard.ccExpiryMonth = _firstIdFormContext.ccExpiryMonth.$viewValue;
              _self.creditCard.ccExpiryYear = _firstIdFormContext.ccExpiryYear.$viewValue;
              break;
            case 'driverLicenseForm':
              _self.driverLicense.dlLicenseNumber = _firstIdFormContext.dlLicenseNumber.$viewValue;
              _self.driverLicense.dlProvince = _firstIdFormContext.dlProvince.$viewValue;
              _self.driverLicense.dlExpiryYear = _firstIdFormContext.dlExpiryYear.$viewValue;
              _self.driverLicense.dlExpiryMonth = _firstIdFormContext.dlExpiryMonth.$viewValue;
              _self.driverLicense.dlExpiryDay = _firstIdFormContext.dlExpiryDay.$viewValue;
              _self.driverLicense.pattern = _self.driverLicense.dlProvince
                ? $scope.dlNumberValidations[_self.driverLicense.dlProvince]
                : null;
              console.log('@buyCreditCheckCtrl:validateField:case driverLicense (_self, $scope) ', _self, $scope);
              break;
            case 'sinForm':
              _self[fieldName].sinNumber = _firstIdFormContext.sinNumber.$viewValue;
              console.log('@buyCreditCheckCtrl:validateField:case sin (_self, $scope) ', _self, $scope);
              break;
            //FHSI Student Permit - START
            case 'studentPermitForm':
              _self[fieldName].studentPermitNumber = _firstIdFormContext.studentPermitNumber.$viewValue;
              _self[fieldName].spExpiryYear = _firstIdFormContext.spExpiryYear.$viewValue;
              _self[fieldName].spExpiryMonth = _firstIdFormContext.spExpiryMonth.$viewValue;
              _self[fieldName].spExpiryDay = _firstIdFormContext.spExpiryDay.$viewValue;
              console.log('@buyCreditCheckCtrl:validateField:case studentPermit (_self, $scope) ', _self, $scope);
              break;
            //FHSI Student Permit - END
            default:
          }
        }

        if (_checkFlag && _secondIdFormName) {
          _secondIdFormContext = _rootForm[setIds($scope.secondIdOption).formName];

          console.log('@validateField:IF 2ID ', _firstIdFormContext, _firstIdFormName);

          switch (_secondIdFormName) {
            case 'creditCardForm':
              // _self[fieldName].ccNumber = _secondIdFormContext.ccNumber.$viewValue;
              // _self[fieldName].ccType = $scope.ccType;
              _self.creditCard.ccNumber = uteSemafoneService.getToken();
              _self.creditCard.ccType = uteSemafoneService.getCardScheme();
              _self[fieldName].ccExpiryMonth = _secondIdFormContext.ccExpiryMonth.$viewValue;
              _self[fieldName].ccExpiryYear = _secondIdFormContext.ccExpiryYear.$viewValue;
              console.log('@validateField:ELSEIF(2ID):case creditCardForm ', _self);
              break;
            case 'driverLicenseForm':
              _self[fieldName].dlLicenseNumber = _secondIdFormContext.dlLicenseNumber.$viewValue;
              _self[fieldName].dlProvince = _secondIdFormContext.dlProvince.$viewValue;
              _self[fieldName].dlExpiryYear = _secondIdFormContext.dlExpiryYear.$viewValue;
              _self[fieldName].dlExpiryMonth = _secondIdFormContext.dlExpiryMonth.$viewValue;
              _self[fieldName].dlExpiryDay = _secondIdFormContext.dlExpiryDay.$viewValue;
              _self[fieldName].pattern = _self.driverLicense.dlProvince
                ? $scope.dlNumberValidations[_self.driverLicense.dlProvince]
                : null;
              console.log('@validateField:ELSEIF(2ID):case driverLicenseForm ', _self);
              break;
            case 'sinForm':
              _self[fieldName].sinNumber = _secondIdFormContext.sinNumber.$viewValue;
              console.log('@validateField:ELSEIF(2ID):case sinForm ', _self);
              break;
            case 'passportForm':
              _self[fieldName].ppNumber = _secondIdFormContext.ppNumber.$viewValue;
              _self[fieldName].ppExpiryDay = _secondIdFormContext.ppExpiryDay.$viewValue;
              _self[fieldName].ppExpiryMonth = _secondIdFormContext.ppExpiryMonth.$viewValue;
              _self[fieldName].ppExpiryYear = _secondIdFormContext.ppExpiryYear.$viewValue;
              console.log('@validateField:ELSEIF(2ID):case passportForm ', _self);
              break;
            case 'citizenshipForm':
              _self[fieldName].citizenshipNumber = _secondIdFormContext.citizenshipNumber.$viewValue;
              console.log('@validateField:ELSEIF(2ID):case citizenshipForm ', _self);
              break;
            case 'employeeForm':
              _self[fieldName].employer = _secondIdFormContext.employer.$viewValue;
              _self[fieldName].employeeNumber = _secondIdFormContext.employeeNumber.$viewValue;
              console.log('@validateField:ELSEIF(2ID):case employeeForm ', _self);
              break;
            case 'certificateForm':
              _self[fieldName].birthCertificateNumber = _secondIdFormContext.birthCertificateNumber.$viewValue;
              console.log('@validateField:ELSEIF(2ID):case certificateForm ', _self);
              break;
            default:
          }
        }
      };

      var _selectedFirstId, _selectedSecondId;

      /*
       * @EventListener $on('$includeContentLoaded')
       * @description handle showing of error messages when toggling back-n-fort from one form ID to another when the previous
       * selected ID has an error while toggling to another
       * @dependencies validateField()
       */
      $scope.$on('$includeContentLoaded', function(ev) {
        var _formIdContext, _firstIdName, _secondIdName, _dateObj, _ccExpiryDateValidity;

        // console.log('++++++', _idTypes()[parseInt($scope.firstIdOption)]);
        // console.log('------', _idTypes()[parseInt($scope.secondIdOption)]);
        // console.log('iiiiii', angular.equals(_selectedFirstId, $scope.firstIdOption), angular.equals($scope.secondIdOption,_selectedSecondId));

        if ($scope.firstIdOption) _firstIdName = _idTypes()[parseInt($scope.firstIdOption)].name;

        if ($scope.secondIdOption) _secondIdName = _idTypes()[parseInt($scope.secondIdOption)].name;

        if ($scope.firstIdOption || $scope.secondIdOption || _selectedFirstId || _selectedSecondId) {
          if (!angular.equals(_selectedFirstId, $scope.firstIdOption)) {
            _formIdContext = $scope.rootCreditCheckForm[_idTypes()[parseInt($scope.firstIdOption)].formName];
          } else if (!angular.equals($scope.secondIdOption, _selectedSecondId)) {
            _formIdContext = $scope.rootCreditCheckForm[_idTypes()[parseInt($scope.secondIdOption)].formName];
          }
        }

        console.log('---FORM_ID_CONTEXT ', _formIdContext);

        switch (_formIdContext.$name) {
          case 'creditCardForm':
            console.log('@buyCreditCheckCtrl:$includeContentLoaded:SECOND_ID:CASE creditCardForm');
            console.log('@buyCreditCheckCtrl:$includeContentLoaded:creditCardForm');
            // _formIdContext.ccExpiryMonth.$setDirty();
            // _formIdContext.ccExpiryYear.$setDirty();

            if ($scope.creditCard.visited && _self.creditCard.ccNumber) {
              $scope.creditCard.ccNumber = _self.creditCard.ccNumber;
              // _formIdContext.ccNumber.$setDirty();
            }

            if ($scope.creditCard.ccExpiryMonth && $scope.creditCard.ccExpiryYear) {
              _ccExpiryDateValidity = $scope.changeCcExpiryDate(
                _formIdContext.ccExpiryMonth.$viewValue,
                _formIdContext
              );
              console.log('@buyCreditCheckCtrl:_ccExpiryDateValidity ', _ccExpiryDateValidity);

              if (!_ccExpiryDateValidity) {
                $scope.creditCard.ccExpiryMonth = _self.creditCard.ccExpiryMonth = '';
                $scope.creditCard.ccExpiryYear = _self.creditCard.ccExpiryYear = '';
                _formIdContext.$setValidity('invalidDate', true);
              } else {
                _formIdContext.ccExpiryMonth.$setDirty();
                _formIdContext.ccExpiryYear.$setDirty();
              }
            }
            break;
          case 'driverLicenseForm':
            console.log('@buyCreditCheckCtrl:$includeContentLoaded:SECOND_ID:CASE driverLicenseForm');
            console.log('@buyCreditCheckCtrl:$includeContentLoaded BEFORE (_self, $scope) ', _self, $scope);

            if ($scope.driverLicense.visited) {
              angular.extend($scope.driverLicense, _self.driverLicense);

              _dateObj = {
                month: _formIdContext.dlExpiryMonth.$viewValue,
                day: _formIdContext.dlExpiryDay.$viewValue,
                year: _formIdContext.dlExpiryYear.$viewValue
              };

              _.defer(function() {
                console.log('$TIMEOUT:@CASE driverLicense STARTED');
                if (_self.driverLicense.dlLicenseNumber) {
                  _formIdContext.dlLicenseNumber.$setDirty();
                  _formIdContext.dlLicenseNumber.$setTouched();
                }

                if (_self.driverLicense.dlExpiryYear) {
                  _formIdContext.dlExpiryYear.$setDirty();
                }

                if (_self.driverLicense.dlExpiryMonth) {
                  _formIdContext.dlExpiryMonth.$setDirty();
                }

                if (_self.driverLicense.dlExpiryDay) {
                  _formIdContext.dlExpiryDay.$setDirty();
                }

                if (_self.driverLicense.dlProvince) {
                  _formIdContext.dlProvince.$setDirty();
                }

                console.log('~INPROG:$TIMEOUT:CASE driverLicenseForm $scope', $scope);

                if (!$scope.driverLicense.validExpiryDate) {
                  $scope.driverLicense.dlExpiryMonth = _self.driverLicense.dlExpiryMonth = '';
                  $scope.driverLicense.dlExpiryYear = _self.driverLicense.dlExpiryYear = '';
                  $scope.driverLicense.dlExpiryDay = _self.driverLicense.dlExpiryDay = '';

                  _formIdContext.$setValidity('invalidDate', true);

                  _formIdContext.dlExpiryYear.$setPristine();
                  _formIdContext.dlExpiryMonth.$setPristine();
                  _formIdContext.dlExpiryDay.$setPristine();
                }

                if (_formIdContext.dlLicenseNumber.$invalid) {
                  $scope.driverLicense.dlLicenseNumber = _self.driverLicense.dlLicenseNumber = '';
                  _formIdContext.dlLicenseNumber.$setPristine();
                  _formIdContext.dlLicenseNumber.$setUntouched();
                }
                $scope.$digest();
              });

              $scope.isDateValid(
                _dateObj,
                _formIdContext,
                '',
                _formIdContext.$name.substr(0, _firstIdName.lastIndexOf('F'))
              );
            }

            console.log('@buyCreditCheckCtrl:$includeContentLoaded AFTER (_self, $scope) ', _self, $scope);
            break;
          case 'sinForm':
            console.log('@buyCreditCheckCtrl:$includeContentLoaded:SECOND_ID:CASE driverLicenseForm');

            if ($scope.sin.visited) {
              $scope.sin = _self.sin;

              $timeout(function() {
                console.log('$TIMEOUT:@CASE sinForm STARTED');
                if (_self.sin.sinNumber) {
                  _formIdContext.sinNumber.$setDirty();
                  _formIdContext.sinNumber.$setTouched();
                }

                if (
                  $scope.rootCreditCheckForm.$error.format ||
                  $scope.rootCreditCheckForm.$error.minlength ||
                  $scope.rootCreditCheckForm.$error.pattern
                ) {
                  $scope.sin.sinNumber = _self.sin.sinNumber = '';

                  _formIdContext.sinNumber.$setPristine();
                  _formIdContext.sinNumber.$setUntouched();
                  _satellite.setVar('error', 'FHSI | buyCreditcheck  failed');
                  _satellite.track('bfa-fhsi-error');
                }
              });
            }

            break;
          case 'passportForm':
            // _self[fieldName].ppNumber = _formIdContext.ppNumber.$viewValue;
            // _self[fieldName].ppExpiryDay = _formIdContext.ppExpiryDay.$viewValue;
            // _self[fieldName].ppExpiryMonth = _formIdContext.ppExpiryMonth.$viewValue;
            // _self[fieldName].ppExpiryYear = _formIdContext.ppExpiryYear.$viewValue;

            console.log('@$includeContentLoaded:BEFORE: case passportForm (_self, $scope) ', _self, $scope);
            if ($scope.passport.visited) {
              angular.extend($scope.passport, _self.passport);

              $timeout(function() {
                console.log('$TIMEOUT:@CASE passportForm STARTED');
                if (_formIdContext.ppNumber) {
                  _formIdContext.ppNumber.$setDirty();
                  _formIdContext.ppNumber.$setTouched();
                }
                if (_self.passport.ppExpiryYear) {
                  _formIdContext.ppExpiryYear.$setDirty();
                }
                if (_self.passport.ppExpiryMonth) {
                  _formIdContext.ppExpiryMonth.$setDirty();
                }
                if (_self.passport.ppExpiryDay) {
                  _formIdContext.ppExpiryDay.$setDirty();
                }

                if (_.values(_formIdContext.ppNumber.$error).length) {
                  $scope.passport.ppNumber = _self.passport.ppNumber = '';

                  _formIdContext.ppNumber.$setPristine();
                  _formIdContext.ppNumber.$setUntouched();
                }

                if (!$scope.passport.validExpiryDate) {
                  $scope.passport.ppExpiryDay = _self.passport.ppExpiryDay = '';
                  $scope.passport.ppExpiryMonth = _self.passport.ppExpiryMonth = '';
                  $scope.passport.ppExpiryYear = _self.passport.ppExpiryYear = '';

                  _formIdContext.$setValidity('invalidDate', true);

                  _formIdContext.ppExpiryDay.$setPristine();
                  _formIdContext.ppExpiryMonth.$setPristine();
                  _formIdContext.ppExpiryYear.$setPristine();
                }
              });
            }

            break;
          case 'citizenshipForm':
            if ($scope.citizenship.visited) {
              angular.extend($scope.citizenship, _self.citizenship);

              $timeout(function() {
                console.log('$TIMEOUT:@CASE citizenshipForm STARTED');
                if (_self.citizenship.citizenshipNumber) {
                  _formIdContext.citizenshipNumber.$setDirty();
                }

                if (_.values(_formIdContext.$error).length) {
                  $scope.citizenship.citizenshipNumber = _self.citizenship.citizenshipNumber = '';

                  _formIdContext.citizenshipNumber.$setPristine();
                }
              });
            }
            console.log('@$includeContentLoaded:case citizenshipForm (_self, $scope) ', _self, $scope);
            break;
          case 'employeeForm':
            if ($scope.employee.visited) {
              angular.extend($scope.employee, _self.employee);

              for (var empField in _self.employee) {
                _.defer(function() {
                  console.log('$TIMEOUT:@CASE employeeForm STARTED');
                  if (_self.employee[empField]) {
                    _formIdContext[empField].$setDirty();
                    _formIdContext[empField].$setTouched();
                  }

                  if (_formIdContext[empField].$invalid) {
                    $scope.employee[empField] = '';
                    _formIdContext[empField].$setPristine();
                    _formIdContext[empField].$setUntouched();
                  }

                  $scope.$digest();
                });
              }
            }
            // _self[fieldName].employer = _formIdContext.employer.$viewValue;
            // _self[fieldName].employeeNumber = _formIdContext.employeeNumber.$viewValue;
            console.log('@$includeContentLoaded:case employeeForm (_self, $scope) ', _self, $scope);
            break;
          case 'certificateForm':
            if ($scope.certificate.visited) {
              angular.extend($scope.certificate, _self.certificate);

              for (var certField in _self.certificate) {
                _.defer(function() {
                  console.log('$TIMEOUT:@CASE certificateForm STARTED');
                  if (_formIdContext[certField]) {
                    _formIdContext[certField].$setDirty();
                  }
                  $scope.$digest();
                });
              }
            }
            // _self[fieldName].birthCertificateNumber = _formIdContext.birthCertificateNumber.$viewValue;
            console.log('@$includeContentLoaded:case certificateForm (_self, $scope) ', _self, $scope);
            break;
          default:
        }

        _selectedFirstId = angular.isDefined($scope.firstIdOption) ? angular.copy($scope.firstIdOption) : '';
        _selectedSecondId = angular.isDefined($scope.secondIdOption) ? angular.copy($scope.secondIdOption) : '';

        // set visited
        if ($scope[_firstIdName] && !$scope[_firstIdName].visited) {
          $scope[_firstIdName].visited = true;
        }
        if ($scope[_secondIdName] && !$scope[_secondIdName].visited) {
          $scope[_secondIdName].visited = true;
        }
      });

      $scope.$on('SearchCustomerDetails:CBPExist', function() {
        notifier.notify.done();
        uteModal.open({
          // templateUrl: 'modules/checkout/views/credit-check-misc-class-modal.html',
          templateUrl: 'modules/checkout/views/credential-exist-modal.html',
          // controller: 'riskClassModalCtrl',
          controller: 'CredentialExistModalCtrl',
          data: {}
        });
      });

      /*
       * @name setCreditCheckRiskClassFlag
       * @description handle credit check page elements visibility after credit-check-evaluation has been done
       */
      function setCreditCheckRiskClassFlag(flag) {
        $scope.creditCheckResultFlag = flag;
      }

      function setRiskClassCode(code) {
        $scope.forms.creditCheck.rcCode = code;
      }

      function setPayloadData() {
        if ($scope.driverLicense && $scope.driverLicense.dlProvince) {
          console.log('----+P ', $scope.driverLicense);
          var _dlNumber = buyUtils.formatDriverLicense(
            $scope.driverLicense.dlProvince,
            $scope.driverLicense.dlLicenseNumber
          );
        }

        var billingAddressTypeFlag = 'billingAddress',
          isAuth =
            $rootScope.ruiMethods.user.is.loggedIn() ||
            ($rootScope.ruiMethods.agent.has.customerContext() && $rootScope.ruiMethods.user.is.agent());

        var data = {
          firstName: $scope.forms.createUser.firstName,
          lastName: $scope.forms.createUser.lastName,
          firstIDType: setIds($scope.firstIdOption).type,
          firstIdentifier: setIds($scope.firstIdOption).value,
          secondIDType: setIds($scope.secondIdOption).type,
          secondIdentifier: setIds($scope.secondIdOption).value,
          dateOfBirth: buyUtils.setCardExpiry({ year: $scope.dob.year, month: $scope.dob.month, day: $scope.dob.day }),
          email: $scope.forms.createUser.email_address,

          ccType: $scope.ccType,
          ccExpiryYear: $scope.creditCard.ccExpiryYear,
          ccExpiryMonth: $scope.creditCard.ccExpiryMonth,
          cardExpiryDate: buyUtils.setCardExpiry({
            year: $scope.creditCard.ccExpiryYear,
            month: $scope.creditCard.ccExpiryMonth
          }),

          province: $scope.driverLicense.dlProvince,
          dlExpiryDate: buyUtils.setCardExpiry({
            year: $scope.driverLicense.dlExpiryYear,
            month: $scope.driverLicense.dlExpiryMonth,
            day: $scope.driverLicense.dlExpiryDay
          }),

          ppExpiryDate: buyUtils.setCardExpiry({
            year: $scope.passport.ppExpiryYear,
            month: $scope.passport.ppExpiryMonth,
            day: $scope.passport.ppExpiryDay
          }),

          ppExpiryMonth: $scope.passport.ppExpiryMonth,
          ppExpiryYear: $scope.passport.ppExpiryYear,
          ppExpiryDay: $scope.passport.ppExpiryDay,

          regNumber: $scope.certificate.birthCertificateNumber,

          employer: $scope.employee.employeeNumber,
          language: $scope.forms.createUser.language.toUpperCase(),

          // The following logic is questionable.
          // Why false when loggedin user or agent regardless of billingAddress status?
          // WHY simply it does not check if billingAddress is not 'serviceAddress'?
          isSA:
            isAuth && $scope.forms.createUser.billingAddress !== 'serviceAddress'
              ? false
              : $scope.forms.createUser.billingAddress === 'serviceAddress'
        };
        //console.log('>>>>>>>>> isAuth', isAuth, 'billingAddress', $scope.forms.createUser.billingAddress, 'data', data);

        if (
          ($rootScope.ruiMethods.user.is.agent() || $rootScope.ruiMethods.user.is.loggedIn()) &&
          commonService.customerHasWirelessService
        ) {
          angular.extend(data, { accountNumber: commonService.wirelessAccountNumber });
        }

        // TODO: refactor
        if ($scope.forms.createUser.billingAddress === 'serviceAddress') {
          billingAddressTypeFlag = 'serviceAddress';
        } else if ($scope.forms.createUser.billingAddress === 'existingBillingAddress') {
          billingAddressTypeFlag = 'existingBillingAddress';
        }

        // FIX for INC0875898 - Invalid Risk Class - START
        // todo: refactor to add 'address' property for service address
        var billingAddressObj = {};
        billingAddressObj =
          billingAddressTypeFlag === 'serviceAddress' || billingAddressTypeFlag === 'billingAddress'
            ? $scope.forms.createUser.data[billingAddressTypeFlag]
            : $scope.forms.createUser.data[billingAddressTypeFlag].address;

        // tbd: there should be a better way of doing this
        angular.extend(data, {
          baCity: _.result(billingAddressObj, 'city', ''),
          baCountry: _.result(billingAddressObj, 'country', ''),
          baPostalCode: _.result(billingAddressObj, 'postalCode', ''),
          baProvince: _.result(billingAddressObj, 'province', ''),
          baStreetDirection: _.result(billingAddressObj, 'streetDirection', ''),
          baStreetName: _.result(billingAddressObj, 'streetName', ''),
          baStreetNumber: _.result(billingAddressObj, 'streetNumber', ''),
          baStreetType: _.result(billingAddressObj, 'streetType', ''),
          baUnitNumber: _.result(billingAddressObj, 'unitNumber', '')
        });
        // FIX for INC0875898 - Invalid Risk Class - END

        // todo: refactor
        angular.extend(data, {
          saCity: _.result($scope.forms.createUser.data.serviceAddress, 'city', ''),
          saCountry: _.result($scope.forms.createUser.data.serviceAddress, 'country', ''),
          saPostalCode: _.result($scope.forms.createUser.data.serviceAddress, 'postalCode', ''),
          saProvince: _.result($scope.forms.createUser.data.serviceAddress, 'province', ''),
          saStreetDirection: _.result($scope.forms.createUser.data.serviceAddress, 'streetDirection', ''),
          saStreetName: _.result($scope.forms.createUser.data.serviceAddress, 'streetName', ''),
          saStreetNumber: _.result($scope.forms.createUser.data.serviceAddress, 'streetNumber', ''),
          saStreetType: _.result($scope.forms.createUser.data.serviceAddress, 'streetType', ''),
          saUnitNumber: _.result($scope.forms.createUser.data.serviceAddress, 'unitNumber', '')
        });

        // set phone property payload depending on saved phoneType
        switch (Number($scope.forms.createUser.phoneType)) {
          case 1:
            angular.extend(data, { mobilePhone: buyUtils.formatPhoneNumber($scope.forms.createUser.phone) });
            break;
          case 2:
            angular.extend(data, { homePhone: buyUtils.formatPhoneNumber($scope.forms.createUser.phone) });
            break;
          case 3:
            angular.extend(data, { businessPhone: buyUtils.formatPhoneNumber($scope.forms.createUser.phone) });
        }

        if (data.firstIDType === 'DRIVER_LICENSE_NUMBER') {
          data.firstIdentifier = _dlNumber;
        } else if (data.secondIDType === 'DRIVER_LICENSE_NUMBER') {
          data.secondIdentifier = _dlNumber;
        }
        //FHSI Student Permit - START

        if (data.firstIDType === 'STUDENT_PERMIT_NUMBER') {
          // FHSI: if firstIDType is 'student permit number', then re-set first identifier type as DL number
          data.firstIDType = 'DRIVER_LICENSE_NUMBER';
          data.dlExpiryDate = buyUtils.setCardExpiry({
            year: $scope.studentPermit.spExpiryYear,
            month: $scope.studentPermit.spExpiryMonth,
            day: $scope.studentPermit.spExpiryDay
          });
          data.province = 'PE'; // set province to PE, since it is required for Student Permit validation in server side
        }
        //FHSI Student Permit - END

        return data;
      }

      function _idTypes() {
        // NOTE: relationship mappings
        // 1: 'modules/checkout/views/fragments/credit-card.html',
        // 2: 'modules/checkout/views/fragments/drivers-license.html',
        // 3: 'modules/checkout/views/fragments/sin.html',
        // 4: 'modules/checkout/views/fragments/passport.html',
        // 5: 'modules/checkout/views/fragments/birth-certificate.html',
        // 6: 'modules/checkout/views/fragments/citizenship.html',
        // 7: 'modules/checkout/views/fragments/senior-citizen.html',
        // 8: 'modules/checkout/views/fragments/employer.html'
        // 9: 'modules/checkout/views/fragments/student-permit.html' //FHSI Student Permit

        return {
          1: {
            type: 'CREDITCARD_NUMBER',
            value: $scope.creditCard.ccNumber,
            formName: 'creditCardForm',
            name: 'creditCard'
          },
          2: {
            type: 'DRIVER_LICENSE_NUMBER',
            value: $scope.driverLicense.dlLicenseNumber,
            formName: 'driverLicenseForm',
            name: 'driverLicense'
          },
          3: { type: 'SIN', value: $scope.sin.sinNumber, formName: 'sinForm', name: 'sin' },
          4: { type: 'PASSPORT', value: $scope.passport.ppNumber, formName: 'passportForm', name: 'passport' },
          5: {
            type: 'BIRTH_CERTIFICATE',
            value: $scope.certificate.birthCertificateNumber,
            formName: 'certificateForm',
            name: 'certificate'
          },
          6: {
            type: 'CITIZENSHIP',
            value: $scope.citizenship.citizenshipNumber,
            formName: 'citizenshipForm',
            name: 'citizenship'
          },
          7: {
            type: 'OLD_AGE_CARD',
            value: $scope.seniorCitizen.senior_citizen_number,
            formName: 'seniorCitizenForm',
            name: 'seniorCitizen'
          },
          8: { type: 'EMPLOYEE_ID', value: $scope.employee.employeeNumber, formName: 'employeeForm', name: 'employee' },
          9: {
            type: 'STUDENT_PERMIT_NUMBER',
            value: 'PERM' + $scope.studentPermit.studentPermitNumber,
            formName: 'studentPermitForm',
            name: 'studentPermit'
          } // prefix 'PERM' to student permit number
        };
      }

      function setIds(IdType) {
        return _idTypes()[IdType];
      }

      function getRiskClassMessage(code) {
        buyService.getRiskClassViewContent(code).then(
          function(resp) {
            $scope.riskClassContent.text = resp;
          },
          function(resp) {
            $scope.riskClassContent.text = resp;
          }
        );
      }

      // TODO relocate
      function saveSession() {
        var creditCheckFormData = $scope.forms.creditCheck.data;
        // creditCheckFormData.driverLicense = $scope.driverLicense;
        // creditCheckFormData.certificate = $scope.certificate;
        // creditCheckFormData.citizenship = $scope.citizenship;
        // creditCheckFormData.creditCard = $scope.creditCard;
        // creditCheckFormData.employee = $scope.employee;
        // creditCheckFormData.passport = $scope.passport;
        // creditCheckFormData.seniorCitizen = $scope.seniorCitizen;
        // creditCheckFormData.sin = $scope.sin;
        creditCheckFormData.dob = $scope.dob;
        creditCheckFormData.firstIdOption = $scope.firstIdOption;
        creditCheckFormData.secondIdOption = $scope.secondIdOption;
        creditCheckFormData.ccType = $scope.ccType;
        creditCheckFormData.resultFlag = $scope.creditCheckResultFlag;
      }
    }
  ]);
})();
